import { render, staticRenderFns } from "./FallbackInterpreter.vue?vue&type=template&id=5a649e1c&"
import script from "./FallbackInterpreter.vue?vue&type=script&lang=ts&"
export * from "./FallbackInterpreter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a649e1c')) {
      api.createRecord('5a649e1c', component.options)
    } else {
      api.reload('5a649e1c', component.options)
    }
    module.hot.accept("./FallbackInterpreter.vue?vue&type=template&id=5a649e1c&", function () {
      api.rerender('5a649e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InterchangeEventDetail/interpreters/FallbackInterpreter.vue"
export default component.exports